module.exports = __webpack_public_path__ + "static/media/Artboard1.57111002.png";